import { Map } from 'immutable';
import { createSelector } from 'reselect';

export const captionsSelector = state =>
  state.getIn(['embed', 'captions'], Map());

export const captionsConfigSelector = createSelector(
  captionsSelector,
  captions => captions.get('config', Map()),
);

export const captionsStyleSelector = createSelector(
  captionsConfigSelector,
  config => config.get('style'),
);

export const embedSlideIdsSelector = state => state.getIn(['embed', 'slides']);

export const tracksByIdSelector = state =>
  state.getIn(['embed', 'tracksById'], Map());

export const videosByIdSelector = state =>
  state.getIn(['embed', 'videosById'], Map());
